import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useMarking from '../../../../../../hooks/maestro/useMarking'
import Countdown from 'react-count-down'
import { toggleAlertModule } from '../../../../../../store/actions/alert.actions'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'

const SaveButtonGroup = () => {
  const groupMarkingStudent = useSelector((state) => state?.classMarking?.groupMarkingStudent || [])
  const loading = useSelector((state) => state?.classMarking?.groupMarkingLoading)
  const alertSave = useSelector((state) => state?.alert?.save || {})

  const dispatch = useDispatch()
  const { onSaveGroupMarking } = useMarking()

  const onSave = async () => {
    await onSaveGroupMarking(groupMarkingStudent)
  }

  // const OPTIONS = {
  //   endDate: currentMode?.endDate || new Date(),
  //   cb: () => onSave()
  // };

  useEffect(() => {
    if (groupMarkingStudent.length) {
      if (!alertSave.mode || !alertSave.onSave) {
        dispatch(toggleAlertModule(false, 'Classes', 'group marking', onSave, alertSave.onDontSave))
      }
    }
  }, [groupMarkingStudent, alertSave])

  return (
    <>
      {/* { currentMode?.endDate && <div style={{ display: 'none' }}> <Countdown options={OPTIONS} /></div>} */}
      {groupMarkingStudent.length > 0 && (
        <ButtonStartIcon
          disabled={loading}
          startIcon={['fal', 'check']}
          loading={loading}
          onClick={onSave}
          className='font-bold '
        >
          Save
        </ButtonStartIcon>
      )}
    </>
  )
}

export default SaveButtonGroup
